import React from 'react'
import { ElementProps } from '../base/element'
import { IStyles } from '../index'
import { MdExpandMore, MdExpandLess } from 'react-icons/md'
import {defStyleChildren} from '../helpers/utils'

import { IComponent, IContainerComponent, IDefaultStyles } from '../schemamanager/types'

export interface IExpansionspanelComponent extends IContainerComponent {
  type: 'expansionspanel'
  label?: string
  expanded?: boolean
  headerComponent?: IComponent,
  styleHeader?: IStyles
  styleLabel?: IStyles
  styleIcon?: IStyles
  styleChildren?: IStyles,
}

export const Expansionspanel = (props: ElementProps) => {
  const { sm, children, themeColor, events, addProps } = props
  const comp = props.comp as IExpansionspanelComponent

  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'my-2',
        boxShadow: 'shadow',
        userSelect: 'select-none'
      }
    },
    styleIcon: {
      classes: {
        height: 'h-8',
        width: 'w-8',
        textColor: themeColor().textColor,
        fontWeight: 'font-bold'
      },
    },
    styleHeader: {
      classes: {
        padding: 'px-8 py-5',
        borderWidth: 'border',
        display: 'flex',
        justifyContent: 'justify-between',
        alignItems: 'items-center',
        cursor: 'cursor-pointer'
      }
    },
    styleLabel: {
      classes: {
        textColor: 'text-grey-800',
        fontWeight: 'font-thin',
        fontSize: 'text-xl'
        
      }
    },
    ...defStyleChildren(),
  }

  const m = props.mergeStyles(style)

  const expClick = () => {
    if (!addProps().disabled) {
      comp.expanded = !comp.expanded
      sm.RenderComponent(comp)
      if (comp.onChange) {
        comp.onChange({ sm, comp })
      }
    }
  }

  return (
    <div {...m.main}>
      <div
        {...m.styleHeader}
        {...events()}
        onClick={expClick}
      >
        {comp.label && (
          <span {...m.styleLabel}>{comp.label}</span>
        )}
        <div className='rounded-full w-7 h-7'>
          {!comp.expanded ? (
            <MdExpandMore {...m.styleIcon} />
          ) : (
            <MdExpandLess {...m.styleIcon} />
          )}
        </div>
      </div>

      {comp.expanded && (
        <div {...m.styleChildren}>{children}</div>
      )}
    </div>
  )
}
